export default __webpack_public_path__ + "static/figure3-ff34b6706273790f079ad1a3d578c263.webp";